import React from 'react'
// import { Link } from 'react-router-dom'
import { Query, Mutation } from 'react-apollo'
import accounting from 'accounting'
import moment from 'moment'
import Datetime from 'react-datetime'
import { Line, Pie } from 'react-chartjs-2'
import _orderBy from 'lodash/orderBy'
import { RIENumber } from 'riek'

import { azure, red, orange, blue, green, gray, purple, pink, black, lineChartDataset, pieChartDataset } from 'variables/chartSettings'

import statsPubblicitaTablePerformanceTipiCampagne from 'graphql/queries/statsPubblicitaTablePerformanceTipiCampagne'
import statsPubblicitaPieCharts from 'graphql/queries/statsPubblicitaPieCharts'
import statsPubblicitaLineChartAndamentoAnnuale from 'graphql/queries/statsPubblicitaLineChartAndamentoAnnuale'
import saveCostoMensile from 'graphql/mutations/saveCostoMensile'
import me from 'graphql/queries/me'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'

// material-ui icons
import ThumbUp from 'material-ui-icons/ThumbUp'
import Timeline from 'material-ui-icons/Timeline'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import IconCard from 'components/Cards/IconCard.jsx'

import Table from 'material-ui/Table'
import TableHead from 'material-ui/Table/TableHead'
import TableCell from 'material-ui/Table/TableCell'
import TableBody from 'material-ui/Table/TableBody'
import TableRow from 'material-ui/Table/TableRow'
import FormControl from 'material-ui/Form/FormControl'
import InputLabel from 'material-ui/Input/InputLabel'
import Select from 'material-ui/Select'
import MenuItem from 'material-ui/Menu/MenuItem'

import 'chart.piecelabel.js'
import chartsStyle from 'assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx'

const price = (amount) => {
  return <span style={{ whiteSpace: 'nowrap' }}>{accounting.formatMoney(amount, '€ ', 0, '.', ',')}</span>
}

const costoCalcolato = (costo, elemento) => {
  if (!elemento) {
    return '-'
  }
  return price(costo / elemento)
}

class Pubblicita extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      meseAnno: moment().format('MMMM YYYY'),
      annoAndamento: moment().format('YYYY'),
      tipoAndamento: 'COSTO',
      tipologiaFiltroRisultati: 'MESE_AZIONE',
      nazione: 'Tutte le nazioni',
      mostraDati: 'mese',
      ruolo: undefined,
    }
  }

  handleChangeCosto =
    (saveCostoMensile, tipoCampagnaId) =>
    ({ costoPubblicita }) => {
      const mese = parseInt(moment(this.state.meseAnno, 'MMMM YYYY').format('MM'), 10)
      const anno = parseInt(moment(this.state.meseAnno, 'MMMM YYYY').format('YYYY'), 10)
      const costo = parseInt(costoPubblicita)

      saveCostoMensile({
        variables: { costoMensile: { tipoCampagnaId, costo: costo, mese, anno } },
      })
    }

  handleChangeNazione = (event) => {
    this.setState({
      nazione: event.target.value,
    })
  }

  handleChangeMostraDati = (event) => {
    this.setState({
      mostraDati: event.target.value,
    })
  }

  handleChangePeriodo = (event) => {
    this.setState({
      meseAnno: moment(event).format('MMMM YYYY'),
    })
  }

  handleChangeAnnoAndamento = (event) => {
    this.setState({
      annoAndamento: moment(event).format('YYYY'),
    })
  }

  handleChangeTipoAndamento = (event) => {
    this.setState({
      tipoAndamento: event.target.value,
    })
  }

  handleChangeTipologiaFiltroRisultati = (event) => {
    this.setState({
      tipologiaFiltroRisultati: event.target.value,
    })
  }
  // RENDER
  renderTablePubblicita = (nazione, mese, anno, tipologiaFiltroRisultati) => {
    return (
      <Query
        query={statsPubblicitaTablePerformanceTipiCampagne}
        variables={{
          nazione: nazione === 'Tutte le nazioni' ? '' : nazione,
          mese: parseInt(mese, 10),
          anno: parseInt(anno, 10),
          tipologiaFiltroRisultati,
        }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>
          {
            /* const campagneNull = data.statsPubblicitaTablePerformanceTipiCampagne[data.statsPubblicitaTablePerformanceTipiCampagne.length - 1]
          data.statsPubblicitaTablePerformanceTipiCampagne.map((stat) => {
            if (stat.tipoCampagnaId === 16 && campagneNull) {
              stat.numeroAppuntamentiFissati += campagneNull.numeroAppuntamentiFissati
              stat.numeroPreliminari += campagneNull.numeroPreliminari
              stat.numeroProposteAcquisto += campagneNull.numeroProposteAcquisto
            }
          })
          delete data.statsPubblicitaTablePerformanceTipiCampagne[data.statsPubblicitaTablePerformanceTipiCampagne.length - 1] */
          }

          return (
            <Mutation
              mutation={saveCostoMensile}
              update={(cache, { data: { saveCostoMensile } }) => {
                const { statsPubblicitaTablePerformanceTipiCampagne: stats } = cache.readQuery({
                  query: statsPubblicitaTablePerformanceTipiCampagne,
                  variables: {
                    nazione,
                    mese: parseInt(mese, 10),
                    anno: parseInt(anno, 10),
                  },
                })
                cache.writeQuery({
                  query: statsPubblicitaTablePerformanceTipiCampagne,
                  variables: {
                    nazione,
                    mese: parseInt(mese, 10),
                    anno: parseInt(anno, 10),
                  },
                  data: {
                    statsPubblicitaTablePerformanceTipiCampagne: stats.map((stat) => {
                      if (stat.tipoCampagnaId === saveCostoMensile.tipoCampagnaId) {
                        return {
                          ...stat,
                          costo: saveCostoMensile.costo,
                        }
                      }
                      return stat
                    }),
                  },
                })
              }}
            >
              {(saveCostoMensile) => {
                const totali = data.statsPubblicitaTablePerformanceTipiCampagne.reduce(
                  (acc, pubblicita) => {
                    return {
                      costo: acc.costo + (pubblicita.costo ? pubblicita.costo : 0),
                      numeroContatti: acc.numeroContatti + (pubblicita.numeroContatti ? pubblicita.numeroContatti : 0),
                      numeroAppuntamentiFissati: acc.numeroAppuntamentiFissati + (pubblicita.numeroAppuntamentiFissati ? pubblicita.numeroAppuntamentiFissati : 0),
                      numeroProposteAcquisto: acc.numeroProposteAcquisto + (pubblicita.numeroProposteAcquisto ? pubblicita.numeroProposteAcquisto : 0),
                      numeroPreliminari: acc.numeroPreliminari + (pubblicita.numeroPreliminari ? pubblicita.numeroPreliminari : 0),
                    }
                  },
                  {
                    costo: 0,
                    numeroContatti: 0,
                    numeroAppuntamentiFissati: 0,
                    numeroProposteAcquisto: 0,
                    numeroPreliminari: 0,
                  }
                )
                return (
                  <div style={{ overflowX: 'scroll' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Tipo</TableCell>
                          <TableCell>Nazione</TableCell>
                          <TableCell>Costo</TableCell>
                          <TableCell>N° contatti</TableCell>
                          <TableCell>Costo / contatto</TableCell>
                          <TableCell>N° appunt.</TableCell>
                          <TableCell>Costo / appunt.</TableCell>
                          <TableCell>N° proposte</TableCell>
                          <TableCell>Costo / proposta</TableCell>
                          <TableCell>N° preliminari</TableCell>
                          <TableCell>Costo / preliminare</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.statsPubblicitaTablePerformanceTipiCampagne.map((pubblicita) => (
                          <TableRow key={pubblicita.tipo || 'Senza campagna'}>
                            <TableCell>{pubblicita.tipo || 'Senza campagna'}</TableCell>
                            <TableCell>{pubblicita.nazione}</TableCell>
                            <TableCell>
                              €&nbsp;
                              <RIENumber className="riek-input" classLoading="loading" classEditing="form-control" value={pubblicita.costo || 0} change={this.handleChangeCosto(saveCostoMensile, pubblicita.tipoCampagnaId)} propName="costoPubblicita" />
                              {/* {price(pubblicita.costo)} */}
                            </TableCell>
                            <TableCell>{pubblicita.numeroContatti}</TableCell>
                            <TableCell>{costoCalcolato(pubblicita.costo, pubblicita.numeroContatti)}</TableCell>
                            <TableCell>{pubblicita.numeroAppuntamentiFissati}</TableCell>
                            <TableCell>{costoCalcolato(pubblicita.costo, pubblicita.numeroAppuntamentiFissati)}</TableCell>
                            <TableCell>{pubblicita.numeroProposteAcquisto}</TableCell>
                            <TableCell>{costoCalcolato(pubblicita.costo, pubblicita.numeroProposteAcquisto)}</TableCell>
                            <TableCell>{pubblicita.numeroPreliminari}</TableCell>
                            <TableCell>{costoCalcolato(pubblicita.costo, pubblicita.numeroPreliminari)}</TableCell>
                          </TableRow>
                        ))}
                        <TableRow style={{ borderBottom: 'none' }}>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                            colSpan={2}
                          >
                            Totale
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                          >
                            €&nbsp;{totali.costo}
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                          >
                            {totali.numeroContatti}
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                          >
                            {costoCalcolato(totali.costo, totali.numeroContatti)}
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                          >
                            {totali.numeroAppuntamentiFissati}
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                          >
                            {costoCalcolato(totali.costo, totali.numeroAppuntamentiFissati)}
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                          >
                            {totali.numeroProposteAcquisto}
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                          >
                            {costoCalcolato(totali.costo, totali.numeroProposteAcquisto)}
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                          >
                            {totali.numeroPreliminari}
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottom: '0',
                              borderTop: '2px solid #ddd',
                              fontWeight: 'bold',
                            }}
                          >
                            {costoCalcolato(totali.costo, totali.numeroPreliminari)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </div>
                )
              }}
            </Mutation>
          )
        }}
      </Query>
    )
  }

  renderPiesPubblicita = (nazione, mese, anno, tipologiaFiltroRisultati) => {
    return (
      <Query
        query={statsPubblicitaPieCharts}
        variables={{
          nazione: nazione === 'Tutte le nazioni' ? '' : nazione,
          mese: parseInt(mese, 10),
          anno: parseInt(anno, 10),
          tipologiaFiltroRisultati,
        }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>

          let campagnaNullIndex
          let campagnaAltroIndex

          data.statsPubblicitaPieCharts.appuntamenti = data.statsPubblicitaPieCharts.appuntamenti.map((stat) => {
            if (stat.tipoCampagna === null) {
              return Object.assign(stat, { tipoCampagna: 'Senza campagna' })
            }
            return stat
          })

          {
            /* data.statsPubblicitaPieCharts.appuntamenti.map((stat, index) => {
            if (stat.tipoCampagna === 'Altro') {
              campagnaAltroIndex = index
            }
            if (stat.tipoCampagna === null) {
              campagnaNullIndex = index
            }
          })

          if (data.statsPubblicitaPieCharts.appuntamenti[campagnaNullIndex]) {
            data.statsPubblicitaPieCharts.appuntamenti[campagnaAltroIndex].valore += data.statsPubblicitaPieCharts.appuntamenti[campagnaNullIndex].valore
          }

          data.statsPubblicitaPieCharts.appuntamenti.splice(campagnaNullIndex, 1) */
          }

          const sortedStats = (type) => {
            return _orderBy(data.statsPubblicitaPieCharts[type], ['valore'], ['desc'])
          }

          const values = (type) => {
            return sortedStats(type).map((stat) => stat.valore)
          }

          const labels = (type) => {
            const sum = function (a, b) {
              return a + b
            }
            return sortedStats(type).map((stat) => Math.round((stat.valore / values(type).reduce(sum, 0)) * 100) + '% - ' + stat.tipoCampagna)
          }

          const datasets = (type) => {
            const hoverColors = [`hsla(${azure}, 0.8)`, `hsla(${red}, 0.8)`, `hsla(${orange}, 0.8)`, `hsla(${blue}, 0.8)`, `hsla(${green}, 0.8)`, `hsla(${gray}, 0.8)`, `hsla(${purple}, 0.8)`, `hsla(${pink}, 0.8)`, `hsla(${black}, 0.8)`]
            const colors = [`hsla(${azure}, 1)`, `hsla(${red}, 1)`, `hsla(${orange}, 1)`, `hsla(${blue}, 1)`, `hsla(${green}, 1)`, `hsla(${gray}, 1)`, `hsla(${purple}, 1)`, `hsla(${pink}, 1)`, `hsla(${black}, 1)`]

            return pieChartDataset(labels(type), colors, colors, hoverColors, values(type))
          }

          const pieChartOptions = (title) => {
            return {
              maintainAspectRatio: false,
              layout: {
                padding: {
                  bottom: 0,
                },
              },
              title: {
                display: true,
                text: title,
                fontSize: 20,
                fontStyle: 'normal',
                padding: 20,
              },
              legend: {
                display: true,
                position: 'right',
                labels: {
                  boxWidth: 13,
                  padding: 10,
                },
              },
              pieceLabel: {
                render: 'percentage',
                fontColor: '#fff',
                position: 'border',
                textShadow: true,
              },
            }
          }

          return (
            <GridContainer justify="space-around" alignItems="flex-start" direction="row" style={{ padding: '60px 0 20px' }}>
              <ItemGrid xs={12} md={8} lg={6} xl={4}>
                <div
                  className="chart-container"
                  style={{
                    height: 300,
                    border: '1px solid #ccc',
                    margin: '10px 0',
                    padding: '0 20px 20px',
                  }}
                >
                  <Pie
                    data={{
                      labels: labels('costi'),
                      datasets: [datasets('costi')],
                    }}
                    options={pieChartOptions('Costi')}
                  />
                </div>
              </ItemGrid>

              <ItemGrid xs={12} md={8} lg={6} xl={4}>
                <div
                  className="chart-container"
                  style={{
                    height: 300,
                    border: '1px solid #ccc',
                    margin: '10px 0',
                    padding: '0 20px 20px',
                  }}
                >
                  <Pie
                    data={{
                      labels: labels('contatti'),
                      datasets: [datasets('contatti')],
                    }}
                    options={pieChartOptions('N° contatti')}
                  />
                </div>
              </ItemGrid>

              <ItemGrid xs={12} md={8} lg={6} xl={4}>
                <div
                  className="chart-container"
                  style={{
                    height: 300,
                    border: '1px solid #ccc',
                    margin: '10px 0',
                    padding: '0 20px 20px',
                  }}
                >
                  <Pie
                    data={{
                      labels: labels('appuntamenti'),
                      datasets: [datasets('appuntamenti')],
                    }}
                    options={pieChartOptions('N° appuntamenti')}
                  />
                </div>
              </ItemGrid>
            </GridContainer>
          )
        }}
      </Query>
    )
  }

  renderGraficoAnnuale = (nazione, anno, tipoAndamento, tipologiaFiltroRisultati) => {
    return (
      <Query
        query={statsPubblicitaLineChartAndamentoAnnuale}
        variables={{
          nazione: nazione === 'Tutte le nazioni' ? '' : nazione,
          anno: parseInt(anno, 10),
          tipoAndamento,
          tipologiaFiltroRisultati,
        }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>

          const chartOptions = {
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                boxWidth: 13,
                padding: 20,
              },
            },
          }

          const datasets = data.statsPubblicitaLineChartAndamentoAnnuale.map((dataset, index) => {
            // DA ELIMINARE QUANDO I COLORI VERRANNO DA SERVER
            const myDataset = { ...dataset }
            const colori = [azure, red, orange, blue, green, gray, purple, pink, black]
            myDataset.color = colori[index]

            return lineChartDataset(myDataset.nome, false, `hsla(${myDataset.color}, 1)`, `hsla(${myDataset.color}, 1)`, myDataset.valori)
          })

          return (
            <div className="chart-container" style={{ height: 600 }}>
              <Line
                data={{
                  labels: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
                  datasets,
                }}
                options={chartOptions}
              />
            </div>
          )
        }}
      </Query>
    )
  }

  render() {
    const { classes } = this.props
    const { meseAnno, annoAndamento, tipoAndamento, tipologiaFiltroRisultati, nazione, mostraDati } = this.state

    const mese = mostraDati === 'mese' ? moment(meseAnno, 'MMMM YYYY').format('MM') : undefined
    const anno = moment(meseAnno, 'MMMM YYYY').format('YYYY')

    return (
      <GridContainer>
        <ItemGrid xs={12}>
          <IconCard
            icon={ThumbUp}
            iconColor="blue"
            title="Pubblicità mensile"
            content={
              <div>
                <GridContainer justify="space-around" alignItems="flex-start" direction="row" style={{ padding: '30px 0' }}>
                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Nazione</InputLabel>
                    <br />
                    <FormControl fullWidth className={classes.selectFormControl}>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        value={nazione}
                        onChange={this.handleChangeNazione}
                        inputProps={{
                          name: 'simpleSelect',
                          id: 'simple-select',
                        }}
                      >
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="Tutte le nazioni"
                        >
                          Tutte le nazioni
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="Italia"
                        >
                          Italia
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="Estero"
                        >
                          Estero
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </ItemGrid>

                  <Query
                    query={me}
                    variables={{
                      promemoriaWhere: {
                        promemoriaDismesso: false,
                        promemoriaDataOra_lte: moment().format('YYYY-MM-DD HH:mm'),
                      },
                    }}
                    fetchPolicy="cache-and-network"
                    pollInterval={180000}
                  >
                    {({ loading, error, data: { me } }) => {
                      if (loading || error) {
                        return null
                      }

                      return me.ruolo === 'ADMIN' ? (
                        <ItemGrid xs={3}>
                          <InputLabel className={classes.label}>Mostra dati per</InputLabel>
                          <br />
                          <FormControl fullWidth className={classes.selectFormControl}>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={mostraDati}
                              onChange={this.handleChangeMostraDati}
                              inputProps={{
                                name: 'simpleSelect',
                                id: 'simple-select',
                              }}
                            >
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                value="mese"
                              >
                                Mese
                              </MenuItem>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                value="anno"
                              >
                                Anno
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </ItemGrid>
                      ) : null
                    }}
                  </Query>

                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Periodo</InputLabel>
                    <br />
                    <FormControl fullWidth>
                      {mostraDati === 'mese' && <Datetime dateFormat="MMMM YYYY" timeFormat={false} value={meseAnno} onChange={this.handleChangePeriodo} />}
                      {mostraDati === 'anno' && <Datetime dateFormat="YYYY" timeFormat={false} value={anno} onChange={this.handleChangePeriodo} />}
                    </FormControl>
                  </ItemGrid>
                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Risultati per</InputLabel>
                    <br />
                    <FormControl fullWidth className={classes.selectFormControl}>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        value={tipologiaFiltroRisultati}
                        onChange={this.handleChangeTipologiaFiltroRisultati}
                        inputProps={{
                          name: 'simpleSelect',
                          id: 'simple-select',
                        }}
                      >
                        {/* <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                        >
                          -- Seleziona --
                        </MenuItem> */}
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="MESE_COMPILAZIONE"
                        >
                          mese compilazione
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="MESE_AZIONE"
                        >
                          mese azione
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </ItemGrid>
                </GridContainer>

                {this.renderTablePubblicita(nazione, mese, anno, tipologiaFiltroRisultati)}
                {this.renderPiesPubblicita(nazione, mese, anno, tipologiaFiltroRisultati)}
              </div>
            }
          />

          <IconCard
            icon={Timeline}
            iconColor="blue"
            title="Andamento annuale"
            content={
              <div>
                <GridContainer justify="space-around" alignItems="flex-start" direction="row" style={{ padding: '30px 0' }}>
                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Nazione</InputLabel>
                    <br />
                    <FormControl fullWidth className={classes.selectFormControl}>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        value={nazione}
                        onChange={this.handleChangeNazione}
                        inputProps={{
                          name: 'simpleSelect',
                          id: 'simple-select',
                        }}
                      >
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="Tutte le nazioni"
                        >
                          Tutte le nazioni
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="Italia"
                        >
                          Italia
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="Estero"
                        >
                          Estero
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </ItemGrid>
                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Anno</InputLabel>
                    <br />
                    <FormControl fullWidth>
                      <Datetime dateFormat="YYYY" timeFormat={false} value={annoAndamento} onChange={this.handleChangeAnnoAndamento} />
                    </FormControl>
                  </ItemGrid>
                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Dati</InputLabel>
                    <br />
                    <FormControl fullWidth className={classes.selectFormControl}>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        value={tipoAndamento}
                        onChange={this.handleChangeTipoAndamento}
                        inputProps={{
                          name: 'simpleSelect',
                          id: 'simple-select',
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                        >
                          -- Seleziona --
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="COSTO"
                        >
                          Costo
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="N_CONTATTI"
                        >
                          N° contatti
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="COSTO_CONTATTI"
                        >
                          Costo/contatto
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="N_APPUNTAMENTI"
                        >
                          N° appuntamenti
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="COSTO_APPUNTAMENTI"
                        >
                          Costo/appuntamento
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </ItemGrid>
                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Risultati per</InputLabel>
                    <br />
                    <FormControl fullWidth className={classes.selectFormControl}>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        value={tipologiaFiltroRisultati}
                        onChange={this.handleChangeTipologiaFiltroRisultati}
                        inputProps={{
                          name: 'simpleSelect',
                          id: 'simple-select',
                        }}
                      >
                        {/* <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                        >
                          -- Seleziona --
                        </MenuItem> */}
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="MESE_COMPILAZIONE"
                        >
                          mese compilazione
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="MESE_AZIONE"
                        >
                          mese azione
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </ItemGrid>
                </GridContainer>

                {this.renderGraficoAnnuale(nazione, annoAndamento, tipoAndamento, tipologiaFiltroRisultati)}
              </div>
            }
          />
        </ItemGrid>
      </GridContainer>
    )
  }
}

export default withStyles(chartsStyle)(Pubblicita)



// WEBPACK FOOTER //
// ./src/views/App/Pubblicita/Pubblicita.jsx